import get from 'lodash/get'

export const apiError = (err) => {
  const detailMessage = get(err, 'response.data.message')
  // eslint-disable-next-line no-undef
  window.alert(detailMessage || err.message)
}
